import axios from 'axios';
import { BASE_URL } from './inquiries';

/**
 * 기술노트 공개 조회. 인증이 없다 — 서버가 발행된 글만 내보낸다.
 *
 * 경로는 평면 `/notes/{slug}` 다(설계 03 §2-2). 카테고리는 허브 `/notes/{카테고리}` 로
 * 따로 있고, 노트 slug 와 카테고리 slug 가 같은 자리를 쓰므로 `cms.reserved_slugs` 가
 * 충돌을 막는다.
 */
const ROOT = `${BASE_URL}/api/notes`;

export const getNoteCategories = async () => (await axios.get(`${ROOT}/categories`)).data;

export const getNotes = async (category) =>
    (await axios.get(ROOT, { params: category ? { category } : undefined })).data;

export const getNote = async (slug) => (await axios.get(`${ROOT}/${slug}`)).data;
